import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLeaderboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M9.75 9a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-1.5a1.5 1.5 0 0 1-1.5-1.5V9Zm3 0h-1.5v10.5h1.5V9ZM3 13.5A1.5 1.5 0 0 1 4.5 12H6a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 6 21H4.5A1.5 1.5 0 0 1 3 19.5v-6Zm3 0H4.5v6H6v-6Zm12-3.75a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 18 21h1.5a1.5 1.5 0 0 0 1.5-1.5v-8.25a1.5 1.5 0 0 0-1.5-1.5H18Zm0 1.5h1.5v8.25H18v-8.25Z"
    />
    <path
      fill="#F7A600"
      d="M14.246 3.302c.023-.118-.067-.26-.18-.26l-1.28-.188-.585-1.226a.18.18 0 0 0-.09-.095c-.113-.07-.248-.023-.315.095l-.562 1.226-1.282.189c-.067 0-.112.023-.135.07a.236.236 0 0 0 0 .33l.922.944-.225 1.344c0 .047 0 .094.023.141.067.118.202.166.315.095l1.146-.637 1.147.637c.022.023.067.023.112.023h.045a.244.244 0 0 0 .18-.283l-.225-1.344.922-.943a.13.13 0 0 0 .067-.118Z"
    />
  </svg>
);
export default SvgTwoColorLeaderboard;
